import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Tabs,
  Nav,
  Tab,
  Table,
  Modal,
  Image,
  Container,
  Card,
  Form
} from "react-bootstrap";
import { appConfig } from "../../config";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactPaginate from "react-paginate";
import Switch from "react-switch";
var dateFormat = require("dateformat");

class AddPurchaseReturns extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: {
        crdtTo: this.props.CreditNotesdtList.orderFrom
          ? this.props.CreditNotesdtList.orderFrom.id
          : null,

        crdtToGST: this.props.CreditNotesdtList.chmstDtls
          ? this.props.CreditNotesdtList.chmstDtls.gstin
          : null,
        addrInfoChmst: this.props.CreditNotesdtList
          ? this.props.CreditNotesdtList.addr
          : null,

        crdtFrom: this.props.CreditNotesdtList.orderTo
          ? this.props.CreditNotesdtList.orderTo.id
          : null,

        id: this.props.CreditNotesdtList
          ? this.props.CreditNotesdtList.id
          : null,
        descp: "",
      
        amnt: "",
        imgUrl: "",
        fileImg: ""
      },
      amntError: "",
      fileError: ""
    };
   
    this.onChange = this.onChange.bind(this);
    this.submit = this.submit.bind(this);
  }

  validate = (filename) => {
    console.log(filename);
    let isError = false;

    const regex = /^\d+(\.\d{1,2})?$/;
    
    if(filename&&filename.imgUrl&&filename!==""){
      this.getExtension = filename => {
        return filename.imgUrl.name.split(".").pop();
      };
    }

    let err = "Please enter a valid credit note amount";
    let err1 = "This field can't be empty";
    let err2 = "Please attach the credit note";
    let err3 = "Only `.jpg`, `.jpeg`, `.png`, `.pdf` files accepted";

    const errors = {
      amntError: "",
      fileError: ""
    };

    if (this.state.value.amnt === "") {
      isError = true;
      errors.amntError = err1;
    }
    if (this.state.value.amnt !== "" && !regex.test(this.state.value.amnt)) {
      isError = true;
      errors.amntError = err;
    }
    if (filename.imgUrl === ""|| !(filename.imgUrl)) {
      isError = true;
      errors.fileError = err2;
    }
    if(filename&&filename.imgUrl&&filename!==""){
      if((this.getExtension(filename) !== "pdf")&&(this.getExtension(filename) !== "jpg")&&(this.getExtension(filename) !== "jpeg")&&(this.getExtension(filename) !== "png")){
        isError=true;
        errors.fileError=err3;
      }
    }

    this.setState({
      ...this.state,
      ...errors
    });

    return isError;
  };

  onChange = event => {
    let name = event.target.name;
    let value = event.target.value;
  if (name === "descp") {
      this.setState({
        value: { ...this.state.value, descp: value }
      });
    } else if (name === "amnt") {
      this.setState({
        value: { ...this.state.value, amnt: value },
        amntError: ""
      });
      
    }
  };

  fileChangedHandler = event => {
    const icon = event.target.files[0];
    if(event.target.files[0]){
      this.setState({
        value: {
          ...this.state.value,
          imgUrl: icon,
          fileImg: URL.createObjectURL(event.target.files[0])
        },
        fileError: ""
      });
    }else{
      this.setState({
        value: {
          ...this.state.value,
          imgUrl: "",
          fileImg:""
        },
        fileError: ""
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: {
        crdtTo:
          nextProps.CreditNotesdtList.orderFrom &&
          nextProps.CreditNotesdtList.orderFrom.id,
        crdtToGST:
          nextProps.CreditNotesdtList.chmstDtls &&
          nextProps.CreditNotesdtList.chmstDtls.gstin,

        addrInfoChmst:
          nextProps.CreditNotesdtList.addr && nextProps.CreditNotesdtList.addr,

        crdtFrom:
          nextProps.CreditNotesdtList.orderTo &&
          nextProps.CreditNotesdtList.orderTo.id,

        id: nextProps.CreditNotesdtList && nextProps.CreditNotesdtList.id
      }
    });
  }
 

  submit = () => {
    let value = this.state.value;
    const validinvoice = this.validate(this.state.value);
    
    if (!validinvoice) {
      this.props.CreditNotesAdd(this.state.value);
      this.setState(
        {
          value:{
            amnt: "",
            imgUrl: "",
            fileImg: "",
          },
          
          amntError: "",
          fileError: ""
        },
        () => {
          this.props.closeAddCreditNotesModel();
        }
      );
    }
  };

  closeModal = () => {
    this.setState({
      value: {
        descp: "",
        fileImg: "",
       
        amnt: "",
        imgUrl: ""
      },
      amntError: "",
      fileError: ""
    });
    this.props.closeAddCreditNotesModel();
  };

  render() {


    return (
      <div>
        <div className="modelboxdesigns">
          <Modal
            show={this.props.showCreditNotesAddModel}
            // onHide={this.closeAddCreditNotesModel}
            onHide={this.closeModal}
            animation={false}
            size="md"
            backdrop="static"
            className="Modalmodelboxdesigns"
            // style={{ backgroundColor: "rgba(0, 0, 0, 0.54)" }}
          >
            <Modal.Header
              style={{
                fontSize: "35px",
                backgroundColor: "#1768B7",
                color: "white"
              }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Create Credit Note</span>
              </Modal.Title>
            </Modal.Header>

           

<Modal.Body>
              <Form>
              
               
               
                <Form.Group as={Row} controlId="payType">
                <Form.Label column sm="4">
                  Amount
                  </Form.Label>
                  <Col sm="8">

                  <Form.Control
                              type="text"
                              autoComplete="off"
                              name="amnt"
                              onChange={this.onChange}
                              value={this.state.value.amnt}
                            />

                            <div className="errStyle">
                              {this.state.amntError}
                            </div>
                  
              
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="payAmnt">
                  <Form.Label column sm="4">
                  Description
                  </Form.Label>
                  <Col sm="8">

                  <Form.Control
                              as="textarea"
                              name="descp"
                              rows="2"
                              autoComplete="off"
                              onChange={this.onChange}
                              value={this.state.value.descp}
                            />
                   
            
                   
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="invoiceimg">
                  <Form.Label column sm="4">
                    Upload Credit Note 
                  </Form.Label>
                  <Col sm="8">
                  
                      <div style={{ display: "grid" }}>
                            
                              {/* <img
                                src={
                                  this.state.value.fileImg
                                    ? this.state.value.fileImg
                                    : require("../../assets/img/img.png")
                                }
                                style={{ height: 100, width: 100 }}
                              /> */}
                              <Form.File
                                style={{ marginTop: "10px" }}
                                id="exampleFormControlFile1"
                                name="img"
                                onChange={this.fileChangedHandler}
                                accept=".png, .jpg, .jpeg, .pdf"
                              />
                              <div
                                className="errStyle"
                                style={{ float: "left" }}
                              >
                                {this.state.fileError}
                              </div>
                            </div>
                  </Col>
                </Form.Group>
              </Form>
            </Modal.Body>




            <Modal.Footer style={{ backgroundColor: "#1768B7" }}>
              <Button className="queryBtn" onClick={this.submit}>
                Create
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

export default AddPurchaseReturns;
